import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map, timeout } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { IncidentForm } from "app/interfaces/incident-form.interface";

const incidentsListUrlApi = environment.incidentsListUrlApi;
const incidentsUrlApi = environment.incidentsUrlApi;
const incidentsOwnerUrlApi = environment.incidentsOwnerUrlApi;
const incidentsVideosUrlApi = environment.incidentsVideosUrlApi;
const incidentsVideosListUrlApi = environment.incidentsVideosListUrlApi;

const incidentsBookmarksCheckUnCheckListUrlApi =
  environment.incidentsBookmarksCheckUnCheckListUrlApi;
const incidentsBookmarksListUrlApi = environment.incidentsBookmarksListUrlApi;
const INCIDENT_WRITE_TIMEOUT_MS = 30000;

@Injectable()
export class IncidentService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getIncidents(
    from: string,
    to: string,
    id_police_station?: string,
    device_id?: string
  ) {
    const body: any = { from, to, id_police_station, device_id };
    return this.http
      .request("POST", `${incidentsListUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getOwnIncidents() {
    return this.http
      .request("GET", `${incidentsOwnerUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getIncidentById(id: number) {
    return this.http
      .request("GET", `${incidentsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateIncidentById(id: number, incidentModel: IncidentForm) {
    delete incidentModel.start_time_day;
    delete incidentModel.start_time_time;
    incidentModel.verbal_warning =
      incidentModel.verbal_warning == true ? Number(1) : Number(0);
    const body = incidentModel;
    return this.http
      .request("PUT", `${incidentsUrlApi}/` + id, { body })
      .pipe(timeout(INCIDENT_WRITE_TIMEOUT_MS), map((resp: any) => resp));
  }

  createIncident(idUser, incidentModel: IncidentForm) {
    delete incidentModel.start_time_day;
    delete incidentModel.start_time_time;
    incidentModel.user_id = idUser;
    incidentModel.verbal_warning =
      incidentModel.verbal_warning == true ? Number(1) : Number(0);
    const body = incidentModel;
    return this.http
      .request("POST", `${incidentsUrlApi}`, { body })
      .pipe(timeout(INCIDENT_WRITE_TIMEOUT_MS), map((resp: any) => resp));
  }

  deleteIncidentById(id: number) {
    return this.http
      .request("DELETE", `${incidentsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  // incident/video
  getVideosIncidents(id: number) {
    return this.http
      .request("GET", `${incidentsVideosUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getVideosIncidentsList(id: number) {
    return this.http
      .request("GET", `${incidentsVideosListUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  createVideoIncident(idIncident: number, idVideo: number) {
    const body = { id_video: idVideo, id_incident: idIncident };
    return this.http
      .request("POST", `${incidentsVideosUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteVideoIncidentById(id: number) {
    return this.http
      .request("DELETE", `${incidentsVideosUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  //incident bookmark

  checkBookmark(idIncident, idUser) {
    const body = {
      id_incident: idIncident,
      id_user: idUser,
      bookmark: true,
    };
    return this.http
      .request("POST", `${incidentsBookmarksCheckUnCheckListUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  unCheckBookmark(idIncident, idUser) {
    const body = {
      id_incident: idIncident,
      id_user: idUser,
      bookmark: false,
    };
    return this.http
      .request("POST", `${incidentsBookmarksCheckUnCheckListUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getIncidentBookmarks() {
    return this.http
      .request("GET", `${incidentsBookmarksListUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }
}
